module.exports = "<div class=\"slidecontainer\">\r\n  <form [formGroup]=\"parentFormGroup\">\r\n    <div class=\"row\">\r\n      <div class=\"col-8\">\r\n         <div #slider id=\"{{parentFormControl}}\" class=\"customSlider\">\r\n         </div>\r\n      </div>\r\n      <div class=\"col-4 text-blue\">\r\n        <h4>{{ getValue()  }}</h4>\r\n      </div>\r\n    </div>\r\n  </form>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/slider/slider.component.html
// module id = ./src/app/shared/components/slider/slider.component.html
// module chunks = main